var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReglamento = function SvgReglamento(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "reglamento_svg__Capa_2",
    viewBox: "0 0 66.22 55.06"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reglamento_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.74 6.76H31.27c-1.04 0-2.06-.42-2.9-1.21l-4.65-4.33C22.87.43 21.86.01 20.82.01H4.98C2.23 0 0 2.89 0 6.46V48.6c0 3.57 2.23 6.46 4.98 6.46h50.19c3.06 0 5.55-3.22 5.55-7.2V13.22c0-3.57-2.23-6.46-4.98-6.46",
    fill: "#22aa9f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.94,
    height: 40.53,
    x: 5.39,
    y: 10.02,
    rx: 4.58,
    ry: 4.58,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.73 19.24H11.27c-2.55 0-4.76 1.76-5.34 4.24L.15 48.33c-.8 3.44 1.81 6.73 5.34 6.73h49.46c2.55 0 4.76-1.76 5.34-4.24l5.79-24.85c.8-3.44-1.81-6.73-5.34-6.73Z",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.46,
    height: 2.78,
    x: 9.38,
    y: 13.5,
    rx: 1.23,
    ry: 1.23,
    fill: "#510c76"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.73,
    height: 2.78,
    x: 29.97,
    y: 13.5,
    rx: 1.23,
    ry: 1.23,
    fill: "#510c76"
  }))));
};
export default SvgReglamento;